// extracted by mini-css-extract-plugin
export default {"box":"SignUp_box__Bx6x5","form":"SignUp_form__MPRo4","modal":"SignUp_modal__xFht7","back":"SignUp_back__LE5C4"};